import React from 'react';
import './LoadingOverlay.scss';

interface Props {
  headerText?: string;
  text?: string;
}

export const LoadingOverlay = (props: Props) => {
  return (
    <div className='loading-overlay'>
      <div className='loading-overlay-container d-flex flex-column'>
        <div className='loading-overlay-spinner'></div>
        <div className='d-flex pt-5 flex-column justify-content-center align-items-center'>
          <div className='font-bold font-14'>{props.headerText}</div>
          <div className='font-20'>{props.text}</div>
        </div>
      </div>
    </div>
  );
};
